import React, { useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export default function ScrollToTopButton({ id, color, title = "Scroll to the top" }) {
  const [buttonDisplay, setButtonDisplay] = useState("none");
  useEffect(() => {
    function onScroll(e) {
      if (window.scrollY > 0) {
        setButtonDisplay("inline-flex");
      } else {
        setButtonDisplay("none");
      }
    }

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (<Fab id={id} color={color} aria-label="Back to top" title={title} sx={{ display: buttonDisplay }}
               onClick={(event) => {
                 window.scrollTo(0, 0);
               }}>
    <ArrowUpwardIcon fontSize="large"/>
  </Fab>);
}